import { ref, createElementBlock, createBlock, unref, openBlock, createVNode, createTextVNode, createElementVNode, toDisplayString } from "vue";
import _sfc_main$1 from "../HtmlEditor/BanzaHtmlViewer.vue.js";
import { PUBLIC_ARTICLE_FOR_VIEW } from "../../graphql/public-articles.js";
import { useApolloGlobalClient } from "../../plugins/apollo.js";
import "lodash-es";
import "moment";
import "../../constants/UserPolicy.js";
import "pinia";
import "../../store/index.js";
import "../../plugins/i18n.js";
import "../../assets/e94e4817134d7c25.png";
import "../../assets/5341da3ffbec0137.png";
import "../../assets/01f50022317dccd7.png";
import "axios";
import "vue-router";
import "maska";
import "../../graphql/queries.js";
import "../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../constants/components/index.js";
/* empty css                         */
import "vuetify/components/VDialog";
import "../../graphql/mutations.js";
import "sweetalert2";
import "@vee-validate/i18n";
/* empty css                        */
import "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import { VProgressCircular } from "vuetify/components/VProgressCircular";
/* empty css                                  */
import "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../assets/8a32dc557a826bf0.png";
/* empty css                     */
import "../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                 */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../Auth/AppleAuthButton/AppleAuthButton.js";
import "../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                               */
import "vuetify/components/VGrid";
import "../Base/index.js";
import "vuex";
/* empty css                        */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../icons/mdi/index.js";
/* empty css                            */
import "vuetify/components/VBtnToggle";
import "../../assets/6f5dc1ff0a697731.svg";
import "../../assets/888bb8db73be3c15.svg";
/* empty css                             */
import "vuetify/components/VInfiniteScroll";
/* empty css                                  */
/* empty css                      */
import "vuetify/components/VChip";
/* empty css                          */
import "../HtmlEditor/index.js";
import "../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                               */
/* empty css                        */
import "../News/NewsModule/NewsModule.vue.js";
import "../News/NewsModule/NewsList.vue.js";
import "../../graphql/news.js";
/* empty css                        */
import "../Pages/index.js";
import "vuetify/components/VWindow";
import "../../assets/5a0af7dd23957928.png";
import "../../graphql/system-settings.js";
import "tiny-emitter/instance";
/* empty css                             */
/* empty css                                    */
import "vuetify/components/VHover";
import "../../constants/NewsGroup.js";
/* empty css                                     */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                   */
import "vuetify/components/VBottomSheet";
import "../../graphql/favorites.js";
import "vue3-runtime-template";
import "../../plugins/tracker/page-tracker.js";
/* empty css                             */
import "../../graphql/notifications.js";
/* empty css                                  */
import "../../constants/CommunicationChannels.js";
/* empty css                            */
import "vuetify/components/VColorPicker";
/* empty css                                                */
import "vuetify/components/VTextarea";
/* empty css                                             */
/* empty css                          */
import "graphql-tag";
import "../../graphql/entity.js";
import "../../graphql/lookups.js";
/* empty css                       */
import "vuetify/components";
/* empty css                             */
/* empty css                     */
import "../../graphql/system-events.js";
/* empty css                                        */
/* empty css                         */
import "vuetify/components/VTooltip";
/* empty css                         */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../graphql/files.js";
/* empty css                            */
import "vuetify/components/VForm";
/* empty css                                 */
/* empty css                                               */
import "vuetify/components/VAlert";
/* empty css                                    */
import "vue-dndrop";
/* empty css                                            */
/* empty css                                    */
import "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
/* empty css                        */
import "vuetify/components/VFileInput";
/* empty css                            */
import "vuetify/components/VAvatar";
/* empty css                                  */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                              */
/* empty css                           */
/* empty css                               */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                  */
import "vuetify/components/VItemGroup";
/* empty css                             */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                        */
import "../../graphql/quartz.js";
import "vue-i18n";
import "../../graphql/integration-systems.js";
import "../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                      */
/* empty css                                    */
import "../../graphql/session-store.js";
import "../../composables/useModalPage.js";
import "../../icons/portal/index.js";
const _hoisted_1 = {
  key: 0,
  class: "d-flex w-100 justify-center pt-12"
};
const _hoisted_2 = { key: 2 };
const _sfc_main = {
  __name: "PublicArticleView",
  props: {
    code: {
      type: String,
      required: true
    },
    disable404: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const client = useApolloGlobalClient();
    const props = __props;
    const isLoaded = ref(false);
    const content = ref(null);
    const loadData = async () => {
      const { data } = await client.query({
        query: PUBLIC_ARTICLE_FOR_VIEW,
        variables: { code: props.code }
      });
      const item = data == null ? void 0 : data.publicArticleByCode;
      content.value = item == null ? void 0 : item.content;
      isLoaded.value = true;
      if (!item && !props.disable404) {
        showError({ statusCode: 404 });
      }
    };
    loadData();
    return (_ctx, _cache) => {
      return !unref(isLoaded) ? (openBlock(), createElementBlock("div", _hoisted_1, [
        createVNode(VProgressCircular, {
          size: 75,
          color: "primary",
          indeterminate: ""
        })
      ])) : unref(content) ? (openBlock(), createBlock(_sfc_main$1, {
        key: 1,
        html: unref(content)
      }, null, 8, ["html"])) : (openBlock(), createElementBlock("div", _hoisted_2, [
        _cache[0] || (_cache[0] = createTextVNode(" 404. Article not found by code ")),
        createElementVNode("b", null, toDisplayString(__props.code), 1),
        _cache[1] || (_cache[1] = createTextVNode(". "))
      ]));
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
